'use strict';

angular.module('dekky.forms.themes.customPartner')
	.run(function($templateCache) {
		$templateCache.put('/dekky.forms/themes/customPartner/row.html',
			'<div class="form-group" ng-class="{\'btn-file-upload\': field.type == \'imageUpload\'}">' +
				'<form-widget field="field" ng-model="model" field-index="fieldIndex"></form-widget>' +
				'<label for="{{ field.name + \'_\' + fieldIndex }}" ng-if="field.label">{{ field.label }}</label>' +
			'</div>'
		);
	});